// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cxu3","fullView":"styles_fullView__29o_L"};